import styled from 'styled-components';
export const ContextualBarStyled = styled.div`
  top: 0;
  left: 0px;
  right: 0px;
  z-index: var(--p-z-index-2);
  background-color: rgb(48, 48, 48);
  padding: 0px 1.5rem;
  position: fixed;
  height: 3rem;
  width: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
`;
